/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeSectionUpdatableDto } from '../models';
// @ts-ignore
import type { SectionTypeDto } from '../models';
// @ts-ignore
import type { UpdateEmployeeSectionContextEnumDto } from '../models';
/**
 * RestEmployeeSectionsUpdaterApi - axios parameter creator
 * @export
 */
export const RestEmployeeSectionsUpdaterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a specific section of employee data based on section type
         * @summary Update Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeSectionUpdatableDto} employeeSectionUpdatableDto Request body for updating an employee section
         * @param {UpdateEmployeeSectionContextEnumDto} [context] Place to put additional context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeSection: async (employeeId: string, sectionType: SectionTypeDto, employeeSectionUpdatableDto: EmployeeSectionUpdatableDto, context?: UpdateEmployeeSectionContextEnumDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateEmployeeSection', 'employeeId', employeeId)
            // verify required parameter 'sectionType' is not null or undefined
            assertParamExists('updateEmployeeSection', 'sectionType', sectionType)
            // verify required parameter 'employeeSectionUpdatableDto' is not null or undefined
            assertParamExists('updateEmployeeSection', 'employeeSectionUpdatableDto', employeeSectionUpdatableDto)
            const localVarPath = `/api/v2/employees/{employeeId}/sections/{sectionType}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"sectionType"}}`, encodeURIComponent(String(sectionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeSectionUpdatableDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmployeeSectionsUpdaterApi - functional programming interface
 * @export
 */
export const RestEmployeeSectionsUpdaterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmployeeSectionsUpdaterApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a specific section of employee data based on section type
         * @summary Update Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeSectionUpdatableDto} employeeSectionUpdatableDto Request body for updating an employee section
         * @param {UpdateEmployeeSectionContextEnumDto} [context] Place to put additional context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeSection(employeeId: string, sectionType: SectionTypeDto, employeeSectionUpdatableDto: EmployeeSectionUpdatableDto, context?: UpdateEmployeeSectionContextEnumDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeSection(employeeId, sectionType, employeeSectionUpdatableDto, context, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmployeeSectionsUpdaterApi.updateEmployeeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmployeeSectionsUpdaterApi - factory interface
 * @export
 */
export const RestEmployeeSectionsUpdaterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmployeeSectionsUpdaterApiFp(configuration)
    return {
        /**
         * Update a specific section of employee data based on section type
         * @summary Update Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeSectionUpdatableDto} employeeSectionUpdatableDto Request body for updating an employee section
         * @param {UpdateEmployeeSectionContextEnumDto} [context] Place to put additional context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeSection(employeeId: string, sectionType: SectionTypeDto, employeeSectionUpdatableDto: EmployeeSectionUpdatableDto, context?: UpdateEmployeeSectionContextEnumDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmployeeSection(employeeId, sectionType, employeeSectionUpdatableDto, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmployeeSectionsUpdaterApi - interface
 * @export
 * @interface RestEmployeeSectionsUpdaterApi
 */
export interface RestEmployeeSectionsUpdaterApiInterface {
    /**
     * Update a specific section of employee data based on section type
     * @summary Update Employee Section
     * @param {string} employeeId 
     * @param {SectionTypeDto} sectionType Type of employee section to retrieve
     * @param {EmployeeSectionUpdatableDto} employeeSectionUpdatableDto Request body for updating an employee section
     * @param {UpdateEmployeeSectionContextEnumDto} [context] Place to put additional context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsUpdaterApiInterface
     */
    updateEmployeeSection(employeeId: string, sectionType: SectionTypeDto, employeeSectionUpdatableDto: EmployeeSectionUpdatableDto, context?: UpdateEmployeeSectionContextEnumDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEmployeeSectionsUpdaterApi - object-oriented interface
 * @export
 * @class RestEmployeeSectionsUpdaterApi
 * @extends {BaseAPI}
 */
export class RestEmployeeSectionsUpdaterApi extends BaseAPI implements RestEmployeeSectionsUpdaterApiInterface {
    /**
     * Update a specific section of employee data based on section type
     * @summary Update Employee Section
     * @param {string} employeeId 
     * @param {SectionTypeDto} sectionType Type of employee section to retrieve
     * @param {EmployeeSectionUpdatableDto} employeeSectionUpdatableDto Request body for updating an employee section
     * @param {UpdateEmployeeSectionContextEnumDto} [context] Place to put additional context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsUpdaterApi
     */
    public updateEmployeeSection(employeeId: string, sectionType: SectionTypeDto, employeeSectionUpdatableDto: EmployeeSectionUpdatableDto, context?: UpdateEmployeeSectionContextEnumDto, options?: RawAxiosRequestConfig) {
        return RestEmployeeSectionsUpdaterApiFp(this.configuration).updateEmployeeSection(employeeId, sectionType, employeeSectionUpdatableDto, context, options).then((request) => request(this.axios, this.basePath));
    }
}

